var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 4.59993C19 6.58812 14.9706 8.19986 10 8.19986C5.02944 8.19986 1 6.58812 1 4.59993M19 4.59993C19 2.61174 14.9706 1 10 1C5.02944 1 1 2.61174 1 4.59993M19 4.59993C18.9977 8.21226 16.1328 11.3506 12.0769 12.1833V17.2C12.0769 18.1941 11.1471 19 10 19C8.85295 19 7.92308 18.1941 7.92308 17.2V12.1833C3.86721 11.3506 1.00234 8.21226 1 4.59993","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Filter.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 20 20","fill":"none"};

module.exports = Filter;

Filter.default = Filter;
